import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const AlertModal = ({
  onCancel,
  onSubmit,
  onClose,
  isOpen,
  title,
  body,
  colorScheme,
}) => {
  const cancelRef = React.useRef();
  const handleProceed = () => {
    onSubmit();
    onClose();
  };
  const handleCancel = () => {
    onClose();
    onCancel();
  };
  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {title}
            </AlertDialogHeader>

            <AlertDialogBody>{body}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={handleCancel} colorScheme="red">
                Cancel
              </Button>
              <Button colorScheme={"green"} onClick={handleProceed} ml={3}>
                Confirm and save
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AlertModal;
